import BaseTrackingController from "../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../data/InteractionEventName";

export default class TrackingController extends BaseTrackingController {

    constructor(dispatcher) {
        super(dispatcher);
    }


    /**
     * @param {ProgressValue} value 
     * @param {Number} elapsedTime in msecs
     */
    trackProgress(value, elapsedTime) {
        this._dispatchProgressEvent(value, elapsedTime);
    }

    /**
     * @param {number} levelNumber Number of level, starting at 1
     * @param {string} ruleId 
     * @param {number} elapsedTime 
     * @param {number} attempt Nr of attempt, starting at 1
     */
    trackLevelStart(levelNumber, ruleId, elapsedTime, attempt) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_STARTED,
            {
                level: levelNumber,
                rule: ruleId,
                attempt: attempt,
            },
            elapsedTime
        );
    }

    /**
     * 
     * @param {number} levelNumber Number of level, starting at 1
     * @param {number} spot Spot that the player selected (number)
     * @param {number} elapsedTime 
     * @param {number} attempt Nr of attempt, starting at 1
     * 
     */
    trackSpotSelected(levelNumber, spot, elapsedTime, attempt) {
        this._dispatchInteractionEvent(
            InteractionEventName.SPOT_SELECTED,
            {
                level: levelNumber,
                attempt: attempt,
                spot: spot
            },
            elapsedTime
        );
    }

    /**
     * 
     * @param {number} levelNumber Number of level, starting at 1
     * @param {number} spot Spot that the player selected (number)
     * @param {number} elapsedTime 
     * @param {number} attempt Nr of attempt, starting at 1
     */
    trackSpotDeselected(levelNumber, spot, elapsedTime, attempt) {
        this._dispatchInteractionEvent(
            InteractionEventName.SPOT_DESELECTED,
            {
                level: levelNumber,
                attempt: attempt,
                spot: spot
            },
            elapsedTime
        );
    }

    /**
     * 
     * @param {number} levelNumber Number of level, starting at 1
     * @param {string} ruleId 
     * @param {boolean} isCorrect Whether the submission was correct
     * @param {Array.<number>} submittedSequence What sequence was submitted
     * @param {Array.<number>} correctSequence What sequence was required
     * @param {number} elapsedTime 
     * @param {number} attempt Nr of attempt, starting at 1
     */
    trackLevelSubmitted(levelNumber, ruleId, isCorrect, submittedSequence, correctSequence, elapsedTime, attempt, submitted_by) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_SUBMITTED,
            {
                level: levelNumber,
                rule: ruleId,
                attempt: attempt,
                correct: isCorrect,
                submitted_by: submitted_by,
                sequence: submittedSequence,
                correct_sequence: correctSequence
            },
            elapsedTime
        );
    }
};
